import { Link } from 'react-router-dom'
import { usePvRechnerSeo } from '../../seo/usePvRechnerSeo'
import { MarketingHeader } from './MarketingHeader'
import { MarketingFooter } from './MarketingFooter'
import { PvSizingTool } from './PvSizingTool'
import { useMarketingHeaderActions } from './useMarketingHeaderActions'

/** Public, anonymous /pv-rechner landing page - German-only like the blog (see usePvRechnerSeo),
 *  no login, nothing persisted. Pure SEO/lead-gen funnel into the real customer flow. */
export function PvRechnerPage() {
  usePvRechnerSeo()
  const headerActions = useMarketingHeaderActions()

  return (
    <>
      <MarketingHeader {...headerActions} />
      <div className="pv-rechner-page">
        <p className="eyebrow">Kostenlos &amp; ohne Anmeldung</p>
        <h1>PV-Rechner: Anlagengröße & Ersparnis in wenigen Minuten</h1>
        <p className="pv-rechner-intro">
          Trage Dachausrichtung, Dachfläche und Stromverbrauch ein und erhalte sofort eine Einschätzung zu
          Anlagengröße, Batteriespeicher und jährlicher Ersparnis - kostenlos, unverbindlich und ohne
          Registrierung - ganz ohne Angabe von Name oder E-Mail-Adresse.
        </p>
        <PvSizingTool onRequestOffer={headerActions.onSelectCustomer} />
        <p className="pv-rechner-cross-link">
          Und was kostet die Anlage dann wirklich?{' '}
          <Link to="/pv-kostenrechner">Durchschnittspreis kostenlos in 2 Sekunden berechnen →</Link>
        </p>
        <p className="pv-rechner-cross-link">
          Mehr zu den Preisfaktoren im Detail:{' '}
          <Link to="/solaranlage-kosten">Preise und Einflussfaktoren im Überblick →</Link>
        </p>
        <p className="pv-rechner-cross-link">
          Übrigens: <Link to="/blog/warum-keine-email-registrierung">Warum wir für diesen Rechner nicht mal eine E-Mail-Adresse brauchen →</Link>
        </p>
      </div>
      <MarketingFooter />
    </>
  )
}
